import { schema } from 'normalizr'

export default [
    new schema.Entity('scheduledTerminations', {}, { idAttribute: 'scheduled_termination_id' }),
]
